import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Image.css';
import { isUrlAbsolute } from '../../utility/fetch-util';
import {imageLocations} from "./ImageLocations";


function DPImg({ imgSrc, isExternal }) {
  return (
    <img
      className="dp-img"
      src={imgSrc}
      alt=""
      crossOrigin={isExternal}
    />
  );
}

DPImg.propTypes = {
  imgSrc: PropTypes.string.isRequired,
};


export function MainImage({ href, imageSrc, isExternal, style, className }) {

  // If there's an href then we want the logo to wrapped in an anchor.
  const Wrapper = useCallback(({ children, ...rest }) => {
    if (href) {
      // Check if the link is going externally. The Link component is only for internal components.
      return isUrlAbsolute(href)
        ? <a href={href} {...rest}>{children}</a>
        : <Link to={href} {...rest}>{children}</Link>;
    }

    return <div {...rest}>{children}</div>;
  }, [href]);

  return (
    <Wrapper style={style} className={`dp-image ${className || ''}`}>
      <DPImg imgSrc={imageSrc} isExternal={isExternal} />
    </Wrapper>
  );
}

MainImage.propTypes = {
  href: PropTypes.string,
  imageSrc: PropTypes.string,
  style: PropTypes.shape({}), // Any JS-CSS style. Too many to define in a prop type.
  className: PropTypes.string,
};

MainImage.defaultProps = {
  href: undefined,
  imageSrc: imageLocations.MAIN_BYNX_LOGO,
  style: undefined,
  className: undefined,
};
